import React, { useState, useEffect } from "react";
import s from "./ControlTJ.module.css";
import { useNavigate } from "react-router-dom";
import {
  setConcentrator,
  setSelectedAgencieToConsult,
} from "../../../store/slices/my_agencies";

import { lastWeek, today } from "../../../helpers/today";

import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  Button,
  TableRow,
  TableCell,
  TableBody,
  Box,
} from "@mui/material";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import NewspaperOutlinedIcon from "@mui/icons-material/NewspaperOutlined";
import MonitorIcon from "@mui/icons-material/Monitor";

import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";

import { getTJcontrol } from "../../../api/saaservices/cashFlow";
import { groupByPdvTerminal, sumField } from "./controlTjGroups";
import { exportExcel } from "../../../helpers/exportExcel";
import { Currency } from "../../../helpers/currencyConvert";
import { useLocation } from "react-router-dom";
import AgencySelectModal from "../../Shared/AgencySelectModal/AgencySelectModal";
import CircularProgress from "@mui/material/CircularProgress";
import {
  AgencyPage,
  getPresentAgencyInPath,
  logOutPath,
  hasAgencyInPath,
  getAgencyNumberDisplay,
} from "../../../helpers/path";
import printTable from "../../../helpers/imprimir";
import { agencieSearchByNumber } from "../../../api/agencies/AgenciesService";
import { updateLocation } from "../../../store/slices/localSlice";
import { getSaaId } from "../../../utils/session.utils";
import { getPrintLogo } from "../../../api/themes/ThemeService";
import ModalFiltros from "./ModalFiltros";
import { CalendarioHoy, CalendarioSemanaPasada } from "../../../helpers/today";

export const ControlTJ = () => {
  const { t } = useTranslation();
  const formatDateOnly = (value) => {
    if (!value) return "-";

    const textValue = String(value);

    if (textValue.includes("T")) {
      return textValue.split("T")[0];
    }

    if (textValue.includes(" ")) {
      return textValue.split(" ")[0];
    }

    return textValue;
  };

  const [controlTJ, setControlTJ] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const agencies = useSelector((state) => state.myAgencies.user_agencies);
  const { activeOrganization } = useSelector((state) => state.gamma);
  const navigate = useNavigate();
  const agencieSelected = useSelector(
    (state) => state.myAgencies?.selected_agencie_to_consult,
  );
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [printing, setPrinting] = useState(false);
  const [search, setSearch] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searching, setSearching] = useState(false);
  const [filters, setFilters] = useState({
    fechadesde: lastWeek(),
    fechahasta: today(),
  });
  const [dateDesde, setDateDesde] = useState(CalendarioSemanaPasada());
  const [dateHasta, setDateHasta] = useState(CalendarioHoy());
  const [loadingAgency, setLoadingAgency] = useState(false);
  const { textColor } = useSelector((state) => state.local);
  const location = useLocation();
  const [logoImpresion, setLogoImpresion] = useState();

  useEffect(() => {
    dispatch(updateLocation({ controltj: true }));
  }, []);

  // Carga el logo una sola vez al montar el componente
  useEffect(() => {
    getPrintLogo()
      .then(setLogoImpresion)
      .catch(() => {});
  }, []);

  // Al hacer click imprimir el logo ya está en estado → disponible en el DOM del render actual
  useEffect(() => {
    if (printing === true) {
      printTable(document.getElementById("controlTJ-table"));
      setPrinting(false);
    }
  }, [printing]);

  async function loadTJControl(agencia, subagencia) {
    const saaId = getSaaId();
    try {
      let data = await getTJcontrol(
        saaId,
        filters.fechadesde,
        filters.fechahasta,
        agencia,
        subagencia,
      );
      return data;
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  function attemptLoadControlTJ() {
    setLoading(true);
    loadControlTJ().then((data) => {
      setControlTJ(data || []);
      setLoading(false);
    });
  }

  async function loadControlTJ() {
    if (agencieSelected) {
      setControlTJ([]);
      const subAgencia =
        agencieSelected.agencyLevel === "CONCENTRATOR"
          ? null
          : agencieSelected.subNumber;
      return loadTJControl(agencieSelected.number, subAgencia);
    }
    return [];
  }

  useEffect(() => {
    if (search) {
      attemptLoadControlTJ();
    }
    setSearch(false);
  }, [search, agencieSelected]);

  useEffect(() => {
    setControlTJ([]);
    const path = location.pathname.split("/");
    if (hasAgencyInPath(path)) {
      const agency = getPresentAgencyInPath(path, agencies);
      if (agency === null) {
        navigate(logOutPath);
      } else {
        dispatch(setSelectedAgencieToConsult(agency));
        attemptLoadControlTJ();
      }
    }
  }, []);

  const getGroupedByPdvTerminal = () => groupByPdvTerminal(controlTJ);

  const grandTotal = (field) => sumField(controlTJ, field);

  const excelItem = () => {
    let excelData = [];
    getGroupedByPdvTerminal().forEach(({ pdv, terminal, rows }) => {
      rows.forEach((item) => {
        excelData.push({
          [t("salePoint")]: pdv,
          [t("terminal")]: terminal,
          [t("date")]: formatDateOnly(item.fecha),
          [t("game")]:
            item.juegoDescripcion ?? item.juegodescripcion ?? item.juego ?? "-",
          [`${t("sales")} ($)`]: item.recaudacion ?? 0,
          [t("postProc")]: item.postprocesos ?? 0,
          [t("commonCancellations")]: item.anuladoscomunes ?? 0,
          [t("specialCancellations")]: item.anuladosespeciales ?? 0,
          [`${t("prizes")} ($)`]: item.premios ?? 0,
          [`${t("paid")} ($)`]: item.pagados ?? 0,
          [`${t("expired")} ($)`]: item.caducos ?? 0,
        });
      });
      excelData.push({
        [t("salePoint")]: `${t("subtotal")} - ${pdv}`,
        [t("terminal")]: terminal,
        [t("date")]: "",
        [t("game")]: "",
        [`${t("sales")} ($)`]: sumField(rows, "recaudacion"),
        [t("postProc")]: sumField(rows, "postprocesos"),
        [t("commonCancellations")]: sumField(rows, "anuladoscomunes"),
        [t("specialCancellations")]: sumField(rows, "anuladosespeciales"),
        [`${t("prizes")} ($)`]: sumField(rows, "premios"),
        [`${t("paid")} ($)`]: sumField(rows, "pagados"),
        [`${t("expired")} ($)`]: sumField(rows, "caducos"),
      });
    });
    excelData.push({
      [t("salePoint")]: `${t("subtotal")} ${t("general")}`,
      [t("terminal")]: "",
      [t("date")]: "",
      [t("game")]: "",
      [`${t("sales")} ($)`]: grandTotal("recaudacion"),
      [t("postProc")]: grandTotal("postprocesos"),
      [t("commonCancellations")]: grandTotal("anuladoscomunes"),
      [t("specialCancellations")]: grandTotal("anuladosespeciales"),
      [`${t("prizes")} ($)`]: grandTotal("premios"),
      [`${t("paid")} ($)`]: grandTotal("pagados"),
      [`${t("expired")} ($)`]: grandTotal("caducos"),
    });
    return excelData;
  };

  const exportToExcel = () => {
    Swal.fire({
      title: t("excelConfirm"),
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "green",
      cancelButtonColor: "#d33",
      cancelButtonText: t("cancel"),
      confirmButtonText: t("accept"),
    }).then((result) => {
      if (result.isConfirmed) {
        exportExcel(excelItem(), t("controlTJ"));
      }
    });
  };

  const handleConsulting = (agencie) => {
    if (agencie) {
      agencieSearchByNumber(activeOrganization?.id, {
        number: agencie?.number,
      })
        .then((response) => {
          dispatch(setConcentrator(response));
          dispatch(setSelectedAgencieToConsult(agencie));
          setLoadingAgency(false);
        })
        .then(() => {
          setSearch(true);
        })
        .catch((e) => {
          console.log(e);
          setLoadingAgency(false);
        });
    }
  };

  const headerCellSx = {
    backgroundColor: "primary.main",
    color: textColor,
    fontSize: "0.8em",
    fontWeight: 500,
    whiteSpace: "normal",
    wordBreak: "break-word",
    textAlign: "center",
    padding: "6px 8px",
  };

  const groups = getGroupedByPdvTerminal();

  return (
    <Grid container className={s.container}>
      <Grid item container xs={11} className={s.header}>
        <Grid item lg={6} md={6} xs={12} className={s.titleContainer}>
          <MonitorIcon sx={{ fontSize: "1.8rem", color: "primary.main" }} />
          <h4>{t("controlTJ")}</h4>
        </Grid>

        <Grid item xs={12} md={6} lg={6} className={s.filters}>
          <Button
            disabled={!agencieSelected}
            variant="contained"
            className={s.filterButton}
            onClick={() => setOpenModal(true)}
          >
            <TuneRoundedIcon
              sx={{ color: "secondary.light", fontSize: "1.8rem" }}
            />
            <p style={{ fontSize: "0.9rem" }}>{t("filter")}</p>
          </Button>
          {searching && (
            <Button
              variant="contained"
              sx={{ ml: 1 }}
              className={s.filterButton}
              onClick={() => {
                setFilters({ fechadesde: lastWeek(), fechahasta: today() });
                setDateDesde(CalendarioSemanaPasada());
                setDateHasta(CalendarioHoy());
                setControlTJ([]);
                setSearching(false);
                setSearch(false);
              }}
            >
              <p style={{ fontSize: "0.9rem" }}>{t("cleanFilters")}</p>
            </Button>
          )}
          {loadingAgency ? (
            <Box sx={{ mx: 7 }}>
              <CircularProgress size="2rem" />
            </Box>
          ) : (
            <Button
              sx={{ ml: 1 }}
              onClick={() => setShowModal(true)}
              color="primary"
              className={s.filterButton}
              variant="contained"
            >
              <p style={{ fontSize: "0.7rem" }}>{t("selectAgency")}</p>
            </Button>
          )}
        </Grid>
      </Grid>

      <Grid className={s.selectAgency} item xs={11}>
        <p style={{ fontSize: "1.3rem", fontWeight: "300" }}>
          {agencieSelected?.name
            ? `${t("salePoint")}: (${agencieSelected.number}${
                agencieSelected.subNumber !== null
                  ? " - " + agencieSelected.subNumber
                  : ""
              }) ${agencieSelected.name}`
            : t("agencyNotSelected")}
        </p>
        {showModal && (
          <AgencySelectModal
            open={showModal}
            setOpen={setShowModal}
            onSelect={handleConsulting}
          />
        )}
      </Grid>

      <Grid
        item
        container
        xs={11}
        sx={{ mt: 3, justifyContent: "flex-end", mb: 3 }}
      >
        <Button
          disabled={!controlTJ?.length}
          size="small"
          variant="contained"
          sx={{ mr: 1, height: "2.5rem" }}
          className={s.optionButton}
          onClick={() => setPrinting(true)}
        >
          <PrintOutlinedIcon
            sx={{ fontSize: "1.5rem", color: textColor }}
            className={s.iconOptions}
          />
        </Button>

        <Button
          disabled={!controlTJ?.length}
          size="small"
          variant="contained"
          sx={{ height: "2.5rem" }}
          className={s.optionButton}
          onClick={() => exportToExcel()}
        >
          <NewspaperOutlinedIcon
            sx={{ fontSize: "1.5rem", color: textColor }}
            className={s.iconOptions}
          />
        </Button>
      </Grid>

      {loading ? (
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
          }}
        >
          <CircularProgress size="3rem" />
        </Grid>
      ) : (
        <>
          {controlTJ?.length ? (
            <Grid
              item
              container
              xs={11}
              className={s.infoContainer}
              id="controlTJ-table"
            >
              {printing && (
                <div className="print-header" style={{ display: "none" }}>
                  <div className="print-header-logo">
                    {logoImpresion?.imgBase64?.length ? (
                      <img src={logoImpresion.imgBase64} alt="logo" />
                    ) : null}
                  </div>
                  <h4 className="print-header-title texto">{t("controlTJ")}</h4>
                  <div className="print-header-date texto">
                    <div>
                      {t("from")}: {filters.fechadesde} — {t("to")}:{" "}
                      {filters.fechahasta}
                    </div>
                    <div>{new Date().toLocaleString("es-AR")}</div>
                  </div>
                </div>
              )}

              <TableContainer className={s.tableContainer}>
                <Table
                  className="print-table"
                  stickyHeader
                  size="small"
                  sx={{
                    tableLayout: "fixed",
                    width: "100%",
                    "& .MuiTableCell-root": {
                      padding: "6px 8px",
                      fontSize: "0.82em",
                    },
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{ ...headerCellSx, width: "7%" }}
                        align="center"
                      >
                        {t("salePoint")}
                      </TableCell>
                      <TableCell
                        sx={{ ...headerCellSx, width: "7%" }}
                        align="center"
                      >
                        {t("terminal")}
                      </TableCell>
                      <TableCell
                        sx={{ ...headerCellSx, width: "8%" }}
                        align="center"
                      >
                        {t("date")}
                      </TableCell>
                      <TableCell
                        sx={{ ...headerCellSx, width: "12%" }}
                        align="center"
                      >
                        {t("game")}
                      </TableCell>
                      <TableCell
                        sx={{ ...headerCellSx, width: "9.4%" }}
                        align="right"
                      >
                        {t("sales")}
                      </TableCell>
                      <TableCell
                        sx={{ ...headerCellSx, width: "9.4%" }}
                        align="right"
                      >
                        {t("postProc")}
                      </TableCell>
                      <TableCell
                        sx={{ ...headerCellSx, width: "9.4%" }}
                        align="right"
                      >
                        {t("commonCancellations")}
                      </TableCell>
                      <TableCell
                        sx={{ ...headerCellSx, width: "9.4%" }}
                        align="right"
                      >
                        {t("specialCancellations")}
                      </TableCell>
                      <TableCell
                        sx={{ ...headerCellSx, width: "9.4%" }}
                        align="right"
                      >
                        {t("prizes")}
                      </TableCell>
                      <TableCell
                        sx={{ ...headerCellSx, width: "9.4%" }}
                        align="right"
                      >
                        {t("paid")}
                      </TableCell>
                      <TableCell
                        sx={{ ...headerCellSx, width: "9.4%" }}
                        align="right"
                      >
                        {t("expired")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {groups.map(({ key, pdv, terminal, rows }) => (
                      <React.Fragment key={key}>
                        {rows.map((item, i) => (
                          <TableRow key={`${key}-${i}`}>
                            <TableCell align="center">{pdv}</TableCell>
                            <TableCell align="center">{terminal}</TableCell>
                            <TableCell align="center">
                              {formatDateOnly(item.fecha)}
                            </TableCell>
                            <TableCell align="center">
                              {item.juegoDescripcion ?? "-"}
                            </TableCell>
                            <TableCell align="right">
                              <Currency value={item.recaudacion ?? 0} />
                            </TableCell>
                            <TableCell align="right">
                              <Currency value={item.postprocesos ?? 0} />
                            </TableCell>
                            <TableCell align="right">
                              <Currency value={item.anuladoscomunes ?? 0} />
                            </TableCell>
                            <TableCell align="right">
                              <Currency value={item.anuladosespeciales ?? 0} />
                            </TableCell>
                            <TableCell align="right">
                              <Currency value={item.premios ?? 0} />
                            </TableCell>
                            <TableCell align="right">
                              <Currency value={item.pagados ?? 0} />
                            </TableCell>
                            <TableCell align="right">
                              <Currency value={item.caducos ?? 0} />
                            </TableCell>
                          </TableRow>
                        ))}
                        <TableRow sx={{ backgroundColor: "rgba(0,0,0,0.05)" }}>
                          <TableCell
                            sx={{ fontWeight: 600, fontSize: "0.85em" }}
                            colSpan={4}
                          >
                            {t("subtotal")} — {t("salePoint")} {pdv} ·{" "}
                            {t("terminal")} {terminal}
                          </TableCell>
                          <TableCell
                            sx={{ fontWeight: 600, fontSize: "0.85em" }}
                            align="right"
                          >
                            <Currency value={sumField(rows, "recaudacion")} />
                          </TableCell>
                          <TableCell
                            sx={{ fontWeight: 600, fontSize: "0.85em" }}
                            align="right"
                          >
                            <Currency value={sumField(rows, "postprocesos")} />
                          </TableCell>
                          <TableCell
                            sx={{ fontWeight: 600, fontSize: "0.85em" }}
                            align="right"
                          >
                            <Currency
                              value={sumField(rows, "anuladoscomunes")}
                            />
                          </TableCell>
                          <TableCell
                            sx={{ fontWeight: 600, fontSize: "0.85em" }}
                            align="right"
                          >
                            <Currency
                              value={sumField(rows, "anuladosespeciales")}
                            />
                          </TableCell>
                          <TableCell
                            sx={{ fontWeight: 600, fontSize: "0.85em" }}
                            align="right"
                          >
                            <Currency value={sumField(rows, "premios")} />
                          </TableCell>
                          <TableCell
                            sx={{ fontWeight: 600, fontSize: "0.85em" }}
                            align="right"
                          >
                            <Currency value={sumField(rows, "pagados")} />
                          </TableCell>
                          <TableCell
                            sx={{ fontWeight: 600, fontSize: "0.85em" }}
                            align="right"
                          >
                            <Currency value={sumField(rows, "caducos")} />
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                    <TableRow sx={{ backgroundColor: "rgba(0,0,0,0.1)" }}>
                      <TableCell
                        sx={{ fontWeight: 700, fontSize: "0.9em" }}
                        colSpan={4}
                      >
                        {t("subtotal")} {t("general") || "General"}
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: 700, fontSize: "0.9em" }}
                        align="right"
                      >
                        <Currency value={grandTotal("recaudacion")} />
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: 700, fontSize: "0.9em" }}
                        align="right"
                      >
                        <Currency value={grandTotal("postprocesos")} />
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: 700, fontSize: "0.9em" }}
                        align="right"
                      >
                        <Currency value={grandTotal("anuladoscomunes")} />
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: 700, fontSize: "0.9em" }}
                        align="right"
                      >
                        <Currency value={grandTotal("anuladosespeciales")} />
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: 700, fontSize: "0.9em" }}
                        align="right"
                      >
                        <Currency value={grandTotal("premios")} />
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: 700, fontSize: "0.9em" }}
                        align="right"
                      >
                        <Currency value={grandTotal("pagados")} />
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: 700, fontSize: "0.9em" }}
                        align="right"
                      >
                        <Currency value={grandTotal("caducos")} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          ) : (
            <Grid
              item
              xs={11}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "200px",
              }}
            >
              <p style={{ fontSize: "1.8rem", fontWeight: 300 }}>
                {searching ? t("noResults") : t("agencyNotSelected")}
              </p>
            </Grid>
          )}
        </>
      )}

      <ModalFiltros
        open={openModal}
        setOpen={setOpenModal}
        setFilters={setFilters}
        setSearching={setSearching}
        setSearch={setSearch}
        dateDesde={dateDesde}
        setDateDesde={setDateDesde}
        dateHasta={dateHasta}
        setDateHasta={setDateHasta}
      />
    </Grid>
  );
};
